import {
  getDetailResultExam,
  getExamStudent, getListResultExam,
  getStudentExamList
} from "../api.js";

  export const state = {
    getExamStudentResponse:{},
    getExamResponse:{},
    pagination: {},
    listResultExam: {},
    detailResultExam: {},
  };

  export const getters = {

    getExamStudentResponse: state =>
    state.getExamStudentResponse ? state.getExamStudentResponse.data : [],
    getExamResponse: state =>
    state.getExamResponse ? state.getExamResponse.data.data : [],
    pagination: state =>
        state.getExamResponse ? state.getExamResponse.data : [],
    listResultExam: state =>
        state.listResultExam ? state.listResultExam : [],
    detailResultExam: state =>
        state.detailResultExam ? state.detailResultExam : [],
  };

  export const mutations = {
    getListExamStudent(state, data) {
      if (!data.error) {
        state.getExamStudentResponse = data;
      } else {
        state.getExamStudentResponse = data.error.response.data.code;
      }
    },
    getListExam(state, data) {
      if (!data.error) {
        state.getExamResponse = data;
      } else {
        state.getExamResponse = data.error.response.data.code;
      }
    },
    getListResultExam(state, data){
      if (!data.error) {
        state.listResultExam = data;
      } else {
        state.listResultExam = data.error.response.data.code;
      }
    },
    getDetailResultExam(state, data){
      if (!data.error) {
        state.detailResultExam = data;
      } else {
        state.detailResultExam = data.error.response.data.code;
      }
    }
  };

  export const actions = {
    async getListExamStudent({ commit }, query) {
      let data = await getExamStudent(query);
      commit("getListExamStudent", data);
    },
    async getListExam({ commit }, query) {
      let data = await getStudentExamList(query);
      commit("getListExam", data);
    },
    async getListResultExam({ commit }, query) {
      let data = await getListResultExam(query);
      commit("getListResultExam", data);
    },
    async getDetailResultExam({ commit }, query) {
      let data = await getDetailResultExam(query);
      commit("getDetailResultExam", data.data);
    }
  };
